import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14bc6fbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__input-group" }
const _hoisted_2 = { class: "form__input-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "text-weight-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_subtitle_1 = _resolveComponent("subtitle-1")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_brand_button = _resolveComponent("brand-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_auth_card = _resolveComponent("auth-card")!
  const _component_body_text_1 = _resolveComponent("body-text-1")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isResetEmailSent)
      ? (_openBlock(), _createBlock(_component_auth_card, { key: 0 }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('login.reset-password', 'Reset Password')), 1)
          ]),
          subtitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(
          'reset-password.go-back',
          'Did you remember your password? Go back to log in'
        )) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/login",
              class: "go-back"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('general.here', 'here')), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Form, {
              "initial-values": $setup.initialValues,
              "validation-schema": $setup.schema,
              onSubmit: $setup.reset
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_subtitle_1, { class: "form__input-group__label-text" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, {
                        name: "envelope",
                        class: "q-mr-sm"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('general.email', 'Email')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Field, { name: "email" }, {
                    default: _withCtx(({ errorMessage, value, field }) => [
                      _createVNode(_component_base_input, _mergeProps({
                        "no-error-icon": "",
                        type: "email",
                        "model-value": value
                      }, field, {
                        "error-message": errorMessage,
                        error: !!errorMessage
                      }), null, 16, ["model-value", "error-message", "error"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_brand_button, {
                    type: "submit",
                    class: "form__submit-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('login.reset-password', 'Reset password')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["initial-values", "validation-schema", "onSubmit"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isResetEmailSent)
      ? (_openBlock(), _createBlock(_component_auth_card, { key: 1 }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('reset-password.check-email', 'Check your email')), 1)
          ]),
          subtitle: _withCtx(() => [
            _createVNode(_component_body_text_1, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.instruction-sent-description', 'We’ve sent instructions to your email')) + " ", 1),
                _hoisted_3,
                _createElementVNode("span", _hoisted_4, _toDisplayString($setup.email), 1),
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t(
              'reset-password.check-spam',
              "If you can't find the email, check your spam folder"
            )), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: { name: 'LogIn' } }, {
              default: _withCtx(() => [
                _createVNode(_component_brand_button, { class: "back-button" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('general.go-back', 'Go back')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}